import { Link } from 'react-router';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// A clinician's invitation waiting for the patient's answer, on Today (C22):
// styled like the new-note card, and leading to the invitation itself, where
// the patient accepts or declines.
export function InvitationCard({ invitation }) {
  const { text, language } = useLanguage();
  const { id, sentAt, clinician } = invitation;
  const sent = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long' }).format(new Date(sentAt));

  return (
    <Link className={ styles.card } to={ `/invitations/${ id }` }>
      <span className={ styles.dot } aria-hidden='true'></span>

      <span className={ styles.lines }>
        <span className={ styles.title }>{ text.wantsToConnect.replace('{name}', `${ clinician.firstName } ${ clinician.lastName }`) }</span>
        <span className={ styles.detail }>{ text.invitationFrom.replace('{date}', sent) }</span>
      </span>

      <span className={ styles.chevron } aria-hidden='true'></span>
    </Link>
  );
}
